<script>
    import { userSettings } from '../store.js';
    import { Modal, ModalBody, ModalFooter, ModalHeader, CustomInput, Button, ButtonGroup } from 'sveltestrap';
    import { createEventDispatcher } from 'svelte';
    import Select from 'svelte-select';

    const dispatch = createEventDispatcher();
    let activeTab = 'Default Views';
    const changeTab = (e) => {
    activeTab = e.detail;
  }
    let shown =false;
    const toggle = () => (shown = !shown);   
    
    let NotifcationLevels = [{value: 0, group: "User", label: "User"}, {value: 1, group: "Group", label: "Group"}]

    let selected = '';

    $: {    
      // Refresh as selected group has changed  
      $userSettings;  
      if($userSettings != null){
        setDefaultSelected();
      }                 
    };
  
    function setDefaultSelected()
    {
        selected = NotifcationLevels[NotifcationLevels.findIndex(notification => notification.value === $userSettings.notificationLevel)];
    }
    

    export async function show() {
        shown = true;
    }  
    
    function _onYes() {
        dispatch('confirm', {
            settings: $userSettings      
        });
    	shown = false;
        resetModal();
    }

    function _onNo() {
    	shown = false;
        resetModal();
    }

    async function handleSelect(selected) {
        $userSettings.notificationLevel = selected.value;
    }
    function resetModal(){
        activeTab = 'Default Views';
    }

</script>
<style>
    

</style>


<Modal isOpen={shown} {toggle}>
    <ModalHeader {toggle}>
        User Settings
    </ModalHeader>
    <ModalBody>
        {#if $userSettings != null}
            <h5>Notifications</h5>
            <label for="notifcationLevels">Notification Level:</label>
            <Select id="user-settings-notifcation-level-select" isClearable={false} isSearchable={false} bind:selectedValue={selected} on:select={() => handleSelect(selected)} items={NotifcationLevels}></Select><br>
            <CustomInput id="user-settings-package-notification-switch" type="switch" name="customSwitch" class="mr-2 lineheight" label="Package Notifications" bind:checked={$userSettings.softwareNotifications}/><br>       
            <CustomInput id="user-settings-deployment-notification-switch" type="switch" name="customSwitch" class="mr-2 lineheight" label="Deployment Notifications" bind:checked={$userSettings.deploymentNotifications}/><br>    
            <CustomInput type="switch" id="user-settings-command-notification-switch" name="customSwitch" class="mr-2 lineheight" label="Command Notifications" bind:checked={$userSettings.installationNotifications}/><br>         
        {/if}
    </ModalBody>
    <ModalFooter>     
        <Button id="user-settings-save-button" on:click={() => _onYes()} color="primary" class="btn-plus btn-icon-split align-bottom float-right">
            <span class="icon text-white-50">
                <i class="fas fa-save"></i>
            </span>
            <span class="text">Save</span>
        </Button>
        <Button id="user-settings-cancel-button" on:click={() => _onNo()} color="primary" class="btn-plus btn-icon-split float-right">
            <span class="icon text-white-50">
                <i class="fas fa-ban"></i>
            </span>
            <span class="text">Cancel</span>
        </Button> 
    </ModalFooter>
</Modal>